import { FileOutlined } from '@ant-design/icons';
import { Badge, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { TableIconSize } from './TableIconSize';
import { IPublicAreaItem } from './getTableTreeDataFromCartelle';

const TableFolderNameWrapper = styled.span`
  text-wrap: wrap;
  /* word-break: break-word; */
`;
const FolderName = styled.span`
  font-size: 16px;
  padding-right: 5px;
  /* fix colori accessibilità test ARC */
  .ant-badge {
    .ant-badge-count {
      background-color: #16395e;
      color: #f0f2f5;
    }
  }
`;
const FolderItemsNumber = styled.span`
  font-size: 12px;
`;

export interface ITableFolderNameProps {
  record: IPublicAreaItem;
}

/**
 * ...
 */
export function TableFolderName(props: ITableFolderNameProps) {
  const { record } = props;
  if (!record.nome) return null;
  const isFolder = record.type === 'folder';

  return (
    <TableFolderNameWrapper>
      <Space>
        {!isFolder && (
          <TableIconSize>
            <FileOutlined />
          </TableIconSize>
        )}
        {isFolder ? (
          <FolderName>
            {record.nome}
            {(record.children?.length ?? 0) > 0 && (
              <Badge
                size="small"
                color="#16395e"
                count={record.children?.length}
                offset={[3, -8]}
              />
            )}
          </FolderName>
        ) : (
          <b>{record.nome}</b>
        )}
      </Space>
    </TableFolderNameWrapper>
  );
}
